<template lang='pug'>
  include ./../../mixins
  div
    //-mobile-accordion

    +b.none-from_lg
      +b.g-row--justify_between.--align_center.--space_none
        +b.color-dark.fs_lg.fs_2lg-lg.font-weight_medium.H1 {{ _('Mobile Files Download') }}
        +b.position_relative
          +b.search-button(@click='openSearch')
          +b.search.position_absolute
            +e.bg.position_relative(:class="{'is-active' : activeSearch}")
              +b.placeholder_white.search-input.INPUT(
                v-model='searchValue'
                ref='search'
                :placeholder="_('Enter your search here')"
              )
      
      +b.card--rounded_xs.--shadow.padding_full_sm.padding_full_1xl-lg.bg_white.margin_top_xl.margin_top_2xl-lg
        +b.DIV(v-for='(category, index) in categories') 
          +b.accordion-wrapper.js-accordion-wrapper.space_bottom_xs(
            @click='expandRow(category, index), getFiles(category.label, category.title)'
            :class="{'is-active' : category.IsExpanded}"
          )
          
            +b.g-row.--align_center
              +b.g-cell.g-cols--auto
                +b.accordion-title.js-accordion-title.P(
                  :class="{'is-active' : category.IsExpanded}"
                ) {{category.title}}

          +b.accordion-content(:class="{'is-active': category.IsExpanded}")
            +b.fs_3sm.table-sort.font-weight_bold.mdi-rotate-90.margin_bottom_lg.margin_top_sm.BUTTON(
              @click='sortName()'
            ) Name
            +b.g-row.--align_center(v-for='(file, index) in filterItems')
              +b.g-cell.g-cols--2
                +b.icon.bgi-basic-contain(v-if='file.type_file !== null')
                  +b.img-basic.IMG(:src="file.type_file.icon_url")
              +b.g-cell.g-cols--auto
                +b.fs_2sm.margin_bottom_sm.line-height_md.P {{file.title}}{{file.type_native}}
                +b.g-row--space_none
                  +b.fs_sm.color_gray-2.margin_right_sm.P {{file.humanSize}}
                  +b.fs_sm.color_gray-2.P {{file.humanDate}}
              +b.g-cell.g-cols--narrow
                +b.color_main-1.mdi.mdi-arrow-collapse-down.A(
                  :href='`${DOWNLOAD_FILE}${file.id}`'
                  :download='`${file.title}${file.type_native}`')
              +b.line--light.margin_vertical_md
              
            +b.text--center(v-if='totalPage > 1')
              +b.SPAN.cursor-pointer.mdi.mdi-arrow-left.color_main-1.margin_right_sm(
                @click="previousPage" 
                :class="{'display display_none' : currentPage == 1}"
              )
              +b.SPAN.cursor-pointer.mdi.mdi-arrow-right.color_main-1(
                @click="nextPage"
                :class="{'display display_none' : currentPage == totalPage}"
              )
          //- +b.text--center.--italic.color_gray.P(v-else) There is no results

    //-desktop version
    +b.appear-from_lg
      +b.g-row--space_xl
        +b.g-cell.g-cols--4
          +b.color-dark.fs_lg.fs_2lg-lg.font-weight_medium.margin_bottom_xl.margin_bottom_2xl-lg.H1 {{_('Files Download')}}
          +b.card--rounded_xs.--shadow.padding_full_1xl.bg_white.margin_top_xl.margin_top_2xl-lg
            +b.catalog-button.BUTTON(
              v-for='(category, index) in categories'  
              @click='expandRow(category, index), getFiles(category.label, category.title)'
              :class="{'is-active' : category.IsExpanded}"
            ) {{category.title}}



        
        +b.g-cell.g-cols--8
          +b.color-dark.fs_lg.fs_2lg-lg.font-weight_medium.margin_bottom_xl.margin_bottom_2xl-lg.H2 {{activeCategoryTitle}}
          +b.card--rounded_xs.--shadow.padding_full_1xl.bg_white.margin_top_xl.margin_top_2xl-lg
            +b.g-row.margin_bottom_xl
              +b.g-cell.g-cols--7
                +b.position_relative
                  +b.form--iconed
                  +b.form--input.placeholder_gray.INPUT(
                    :placeholder="_('Enter your search here')"
                    v-model='searchValue'
                  )
              +b.g-cell.g-cols--5
                +b.button--color_blue.--width_full.fs_2md.BUTTON(
                  @click='downloadArchive()'
                ) {{_("Download All Files")}}
            +b.DIV(v-if='showResponse')
              +b.block-table.TABLE
                +e.row--download.TR
                  +e.data--download.TD 
                  +e.data--download.TD
                    +b.fs_3sm.table-sort.font-weight_bold.mdi-rotate-90.cursor-pointer.BUTTON(
                      @click='sortName()'
                    ) Name
                  +e.data--download.TD
                    +b.fs_3sm.table-sort.font-weight_bold.mdi-rotate-90.cursor-pointer.BUTTON(
                      @click='sortDate()'
                    ) Date
                  +e.data--download.TD
                    +b.fs_3sm.table-sort.font-weight_bold.mdi-rotate-90.cursor-pointer.BUTTON(
                      @click='sortSize()'
                    ) Size
                  +e.data--download.TD
                    +b.
                
                +e.row--download.TR(v-for='(file, index) in filterItems')
                  +e.data--download.TD
                    +b.icon.bgi-basic-contain(v-if='file.type_file !== null')
                      +b.img-basic.IMG(:src="file.type_file.icon_url")
                  +e.data--download.TD
                    +b.fs_3sm.line-height_md.line-height_md.P {{ file.title }}{{ file.type_native }}
                  +e.data--download.TD
                    +b.text--italic.fs_3sm.color_main-3.P {{file.humanDate}}
                  +e.data--download.TD
                    +b.text--italic.fs_3sm.color_main-3.P {{file.humanSize}}
                  +e.data--download.TD
                    +b.color_main-1.mdi.mdi-arrow-collapse-down.cursor-pointer.A(
                      :href='`${DOWNLOAD_FILE}${file.id}`'
                      :download='`${file.title}${file.type_native}`'
                    ) 
                      span.fs_3sm.margin_left_sm {{_('Download')}}

            +b.text--center.--italic.color_gray.P(v-else) {{_('There is no result')}}
            +b.text--center(v-if='totalPage > 1')
              +b.SPAN.cursor-pointer.mdi.mdi-arrow-left.color_main-1.margin_right_sm(
                @click="previousPage" 
                :class="{'display display_none' : currentPage == 1}"
              )
              +b.SPAN.cursor-pointer.mdi.mdi-arrow-right.color_main-1(
                @click="nextPage"
                :class="{'display display_none' : currentPage == totalPage}"
              )

</template>



<script>

import FormMixin, { defaultValidatorErrorsParser } from './../../mixins/form-mixin'
import { categoryResource, filesResource, GET_LIST, DOWNLOAD_FILE, DOWNLOAD_ARCHIVE } from '@services/downloading'
import { createResource } from '@resource/resource'
export default {
  mixins: [FormMixin],
  data() {
    return {
      DOWNLOAD_FILE,
      DOWNLOAD_ARCHIVE,
      baseUrl: '',
      openAcc: false,
      categories: [],
      files: [],
      activeSearch: false,
      searchValue: '',
      name: false,
      date: false,
      size: false,
      url: window.location.href,
      activeCategory: '',
      activeCategoryTitle: '',

      pageSize: 10,
      currentPage: 1,
      totalPage: 0,
      showUpto: 10,
      showFromto: 0,

      showResponse: false,
    }
  },
  
  async mounted() {
    await this.getData()

    await this.get()
      

  },

  methods: {
    get() {
      let url = window.location.pathname.split('file-list/')
      this.baseUrl = window.location.pathname
      if (url[1]) {
        let category = url[1].split('/')[0]
        let currentCat = this.categories.find(el => el.label == category)
        this.baseUrl = window.location.pathname.split(category)[0]
        this.getFiles(category, this.categories[0].title)
        this.expandRow(currentCat, 0)

      
      } else {
        this.getFiles(this.categories[0].label, this.categories[0].title)
        this.expandRow(this.categories[0], 0)
      }
    },
    sortName() {
      this.name = !this.name
      this.files.sort((a, b) => {
        let titleA = a.title.toLowerCase(), 
            titleB = b.title.toLowerCase()
        if ( this.name ? titleA < titleB : titleA > titleB)
          return -1
        if ( this.name ? titleA > titleB : titleA < titleB)
          return 1
        return 0
      })
    },

    sortDate() {
      this.date = !this.date
      this.files.sort((a, b) => {
        let dateA = new Date(a.created_at),
            dateB = new Date(b.created_at)
        return (this.date ? dateA - dateB : dateB - dateA)
      })
    },

    sortSize() {
      this.size = !this.size
      this.files.sort((a, b) => {
        let sizeA = a.size,
            sizeB = b.size
        return (this.size ? sizeA - sizeB : sizeB - sizeA)
      })
    },

    openSearch() {
      this.$refs.search.focus()
      this.activeSearch = !this.activeSearch
      this.activeSearch ? this.$refs.search.focus() : this.$refs.search.blur()

    },

    getData() {
      return categoryResource.execute({})
        .then((res) => {
          this.categories = res.data
        })
    },

    humanFileSize(size) {
      let one = 1
      let two = 2
      let i = Math.floor( Math.log(size) / Math.log(1024) )
      return ( size / Math.pow(1024, i) ).toFixed(two) * one + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i]
    },

    humanData(el) {
      let date = el.substr(0, 10)
      const [year, month, day] = date.split('-')
      return el = [day, month, year].join('.')
    },

    getFiles(item, label) {
      this.activeCategoryTitle = label
      this.activeCategory = item
      this.files = []
      let url = ''
      let resource = createResource(GET_LIST + item)
      return resource.execute({})
        .then((res) => {
          this.files = res.data
          this.showResponse = true
          url = this.baseUrl + item

          this.files.forEach((el) => {
            el['humanSize'] = this.humanFileSize(el.size)
            el['humanDate'] = this.humanData(el.created_at)
          })
          history.pushState('', 'Title', url)
        })
    },

    downloadArchive() {
      let resource = DOWNLOAD_ARCHIVE + this.activeCategory
      window.open(resource)
    },

    expandRow(category, ind) {
      let isOpen = category.IsExpanded
      let rowData = []

      rowData = this.categories.map(x => {
        x.IsExpanded = false 
        return x
      })
      if (window.matchMedia("(max-width: 992px)").matches) {
        this.categories = rowData
        category.IsExpanded = !isOpen
      } else {
        category.IsExpanded = true
      }
    },

    changeSelect() {
      this.showUpto = this.pageSize
      this.currentPage = 1
      this.showFromto = 0
    },

    nextPage() {
      if (this.currentPage != this.totalPage){
        this.showFromto = (this.currentPage * this.pageSize) 
        this.currentPage =  this.currentPage + 1
        this.showUpto = (this.currentPage * this.pageSize) 
      }   
    },

    previousPage() {
      if (this.currentPage != 1){
        this.showFromto = ((this.currentPage - 2) * this.pageSize) 
        this.currentPage =  this.currentPage - 1
        this.showUpto = (this.currentPage * this.pageSize) 
      }   
    }
  },
  computed: {
    filterItems() {
      let id = Object.keys(this.files)
      let result
      if (id.length > 0 && this.files.length > 0) {
        result = this.files.filter(item => {
          return item.title.toLowerCase().includes(this.searchValue.toLowerCase())
        })
      } else {
        result = this.files
      }
      
      let list = result.slice(this.showFromto, this.showUpto)
      this.totalPage = Math.ceil(result.length / this.pageSize)
      return list
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/js/components/DownloadingFiles/DownloadingFiles.vue